import React from 'react';

const FeedEntityContext = React.createContext();

export function useFeedEntityContext() {
  return React.useContext(FeedEntityContext);
}

export default FeedEntityContext;
